var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-input',{attrs:{"title":_vm.title,"model":_vm.schema.$regex},on:{"input":function($event){return _vm.$emit('update')}}})}
var staticRenderFns = []

export { render, staticRenderFns }